import * as yup from "yup";
import { subYears } from "date-fns";

/* ---------------------------
Reusable Social URL Validator
----------------------------*/
const socialUrl = (domain, message) =>
  yup.string().nullable().test("url-validation", message, (value) => {
    if (!value) return true;
    const regex = new RegExp(`^(https?:\\/\\/)?(www\\.)?${domain}\\/.*`, "i");
    return regex.test(value);
  });

export const profileSchema = yup.object().shape({
  fullName: yup
    .string()
    .required("Name is required")
    .min(3, "At least 3 chars"),

  email: yup
    .string()
    .email("Invalid email")
    .required("Email is required"),

  mobileNumber: yup
    .string()
    .matches(/^[+]?[0-9]{10,15}$/, "Invalid mobile")
    .required("Mobile is required"),

  alternateMobileNumber: yup.string().nullable(),

  // educationLevel: yup
  //   .string()
  //   .required("Education Level is required"),
 educationLevel: yup.object().shape({
    value: yup.string().required('Education Level is required'),
    label: yup.string().required(),
  }).nullable().required('Education Level is required'),


  dateOfBirth: yup
    .date()
    .nullable()
    .required("Date of Birth is required")
    .max(new Date(), "Date cannot be in future")
    .min(subYears(new Date(), 100), "Date cannot be more than 100 years ago"),

  // gender: yup
  //   .string()
  //   .required("Gender is required"),
  gender: yup.object().shape({
      value: yup.string().required('Gender is required'),
      label: yup.string().required(),
  }).nullable().required('Gender is required'),

  // specialCategory: yup.string().nullable(),
   special_category: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),

  // nationality: yup
  //   .string()
  //   .required("Nationality is required"),
 nationality: yup.object().shape({
    value: yup.string().required('Nationality is required'),
    label: yup.string().required(),
  }).nullable().required('Nationality is required'),

  // countryOfResidence: yup
  //   .string()
  //   .required("Country is required"),
  countryOfResidence: yup.object().shape({
    value: yup.string().required('Country is required'),
    label: yup.string().required(),
  }).nullable().required('Country is required'),


  // preferredCurrency: yup
  //   .string()
  //   .required("Currency is required"),
   preferredCurrency: yup.object().shape({
    value: yup.string().required('Currency is required'),
    label: yup.string().required(),
  }).nullable().required('Currency is required'),

  talents: yup
    .array()
    .min(1, "Select at least one talent")
    .required("Talent is required"),

  aboutYourself: yup
    .string()
    .required("About yourself is required")
    .min(20, "Min 20 characters"),

  /* ---------------------------
     PAN / Aadhar Validation
  ----------------------------*/

  // panNumber: yup
  //   .string()
  //   .test(
  //     "pan-or-aadhar",
  //     "Either PAN or Aadhar is required",
  //     function (value) {
  //       const { aadharNumber } = this.parent;
  //       return !!(value || aadharNumber);
        
  //     }
  //   )
  //   .test(
  //     "pan-validation",
  //     "Invalid PAN Card format",
  //     (value) => {
  //       if (!value) return true;
  //       return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value.toUpperCase());
  //     }
      
  //   ),
  panNumber: yup
  .string()
  .nullable()
  .test(
    "pan-or-aadhar",
    "Either PAN or Aadhar is required",
    function (value) {
      const { aadharNumber } = this.parent;

      if (!value && !aadharNumber) return false;
      return true;
    }
  )
  .test(
    "pan-validation",
    "Invalid PAN Card format",
    function (value) {
      if (!value) return true; // optional
      return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value.toUpperCase());
    }
  ),

  // aadharNumber: yup
    // .string()
    // .test(
    //   "pan-or-aadhar",
    //   "Either PAN or Aadhar is required",
    //   function (value) {
    //     const { panNumber } = this.parent;
    //     return !!(value || panNumber);
    //   }
    // )
    // .test(
    //   "aadhar-validation",
    //   "Aadhar must be 12 digits",
    //   (value) => {
    //     if (!value) return true;
    //     return /^\d{12}$/.test(value);
    //   }
    // ),
    aadharNumber: yup
  .string()
  .nullable()
  .test(
    "pan-or-aadhar",
    "Either PAN or Aadhar is required",
    function (value) {
      const { panNumber } = this.parent;

      if (!value && !panNumber) return false;
      return true;
    }
  )
  .test(
    "aadhar-validation",
    "Aadhar must be 12 digits",
    function (value) {
      if (!value) return true; // optional
      return /^\d{12}$/.test(value);
    }
  ),

  /* ---------------------------
     Physical Attributes
  ----------------------------*/

  weight: yup
    .number()
    .typeError("Weight must be a number")
    .nullable()
    .required("Weight is required")
    .min(1, "Min 1 Kg")
    .max(300, "Max 300 Kg"),

  heightFeet: yup
    .number()
    .nullable()
    .required("Feet is required")
    .min(1, "Min 1 foot")
    .max(8, "Max 8 feet")
    .typeError("Feet must be a number"),

  heightInches: yup
    .number()
    .nullable()
    .required("Inches is required")
    .min(0, "Min 0 inch")
    .max(11, "Max 11 inches")
    .typeError("Inches must be a number"),

  // eyeColour: yup
  //   .string()
  //   .required("Eye Colour is required"),

  // skinType: yup
  //   .string()
  //   .required("Skin Type is required"),

  // bodyType: yup
  //   .string()
  //   .required("Body Type is required"),

  // hairType: yup
  //   .string()
  //   .required("Hair Type is required"),

  // hairColor: yup
  //   .string()
  //   .required("Hair Color is required"),
  eyeColour: yup.object().shape({
      value: yup.string().required('Eye Colour is required'),
      label: yup.string().required(),
  }).nullable().required('Eye Colour is required'), 
  skinType: yup.object().shape({
      value: yup.string().required('Skin Type is required'),
      label: yup.string().required(),
  }).nullable().required('Skin Type is required'), 
  bodyType: yup.object().shape({
      value: yup.string().required('Body Type is required'),
      label: yup.string().required(),
  }).nullable().required('Body Type is required'), 
  hairType: yup.object().shape({
      value: yup.string().required('Hair Type is required'),
      label: yup.string().required(),
  }).nullable().required('Hair Type is required'), 
  hairColor: yup.object().shape({
      value: yup.string().required('Hair Color is required'),
      label: yup.string().required(),
  }).nullable().required('Hair Color is required'), 



  // peopleAppearanceList: yup.string().nullable(),
  peopleAppearanceList: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),

  // drivingType: yup.string().nullable(),
  drivingType: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),

  sportsType: yup.array().nullable(),

  esportsType: yup.array().nullable(),

  /* ---------------------------
     Address
  ----------------------------*/

  addressType: yup.string().default("primary"),

  pinCode: yup
    .string()
    .required("Pin Code required")
    .matches(/^\d{6}$/, "Pin Code must be 6 digits"),

  addressLine1: yup
    .string()
    .required("Address Line 1 required"),

  addressLine2: yup.string().nullable(),

  state: yup
    .string()
    .required("State required"),

  district: yup
    .string()
    .required("District required"),

  /* ---------------------------
     Social Media Validation
  ----------------------------*/

  facebookProfileUrl: socialUrl(
    "facebook.com",
    "Enter valid Facebook URL"
  ),

  linkedinProfileUrl: socialUrl(
    "linkedin.com",
    "Enter valid LinkedIn URL"
  ),

  instagramProfileUrl: socialUrl(
    "instagram.com",
    "Enter valid Instagram URL"
  ),

  twitterProfileUrl: socialUrl(
    "x.com",
    "Enter valid Twitter URL"
  ),

  youtubeUrl: socialUrl(
    "(youtube.com|youtu.be)",
    "Enter valid YouTube URL"
  ),

  imdbUrl: socialUrl(
    "imdb.com",
    "Enter valid IMDB URL"
  ),

  whatsappNo: yup.string().nullable(),
});